import { PHOTOS } from "../lib/site";

const HOURS = [
  { day: "Lunedì", time: "09:00 – 19:30" },
  { day: "Martedì", time: "09:00 – 19:30" },
  { day: "Mercoledì", time: "09:00 – 19:30" },
  { day: "Giovedì", time: "09:00 – 19:30" },
  { day: "Venerdì", time: "09:00 – 19:30" },
  { day: "Sabato", time: "Chiuso", closed: true },
  { day: "Domenica", time: "Chiuso", closed: true },
];

export default function Hours() {
  // Get current day index (Monday = 0)
  const jsDay = new Date().getDay(); // 0 Sun .. 6 Sat
  const todayIdx = jsDay === 0 ? 6 : jsDay - 1;

  return (
    <section
      id="orari"
      data-testid="hours-section"
      translate="no"
      lang="it"
      className="notranslate relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <div className="ee-eyebrow">Orari</div>
          <h2
            data-testid="hours-title"
            className="font-serif-display mt-4 text-[34px] sm:text-[46px] lg:text-[54px] leading-[1.08] tracking-[-0.01em] text-[var(--ee-ink)]"
          >
            Orari di
            <em className="italic text-[var(--ee-rose-strong)]"> apertura</em>.
          </h2>
          <p className="mt-5 text-[15px] sm:text-[16px] leading-[1.7] text-[var(--ee-ink-soft)] max-w-md">
            Siamo aperti dal lunedì al venerdì. Per garantire il miglior
            servizio consigliamo sempre di prenotare in anticipo.
          </p>

          <div className="mt-8 ee-img-frame aspect-[4/3] hidden lg:block max-w-sm">
            <img
              src={PHOTOS.manicurePostazione}
              alt="Postazione manicure — Estetica Elite"
              className="w-full h-full object-cover"
              data-testid="hours-image"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <ul
            data-testid="hours-list"
            className="ee-card overflow-hidden bg-white divide-y divide-[var(--ee-line)]"
          >
            {HOURS.map((h, i) => {
              const isToday = i === todayIdx;
              return (
                <li
                  key={h.day}
                  data-testid={`hours-row-${h.day.toLowerCase()}`}
                  className={`flex items-center justify-between px-6 sm:px-9 py-5 transition-colors ${
                    isToday ? "bg-[var(--ee-blush-soft)]" : ""
                  }`}
                >
                  <span
                    className={`text-[15px] sm:text-[16px] ${
                      isToday
                        ? "text-[var(--ee-rose-strong)] font-semibold"
                        : "text-[var(--ee-ink)]"
                    }`}
                  >
                    {h.day}
                    {isToday && (
                      <span className="ml-3 text-[10px] uppercase tracking-[0.2em] text-[var(--ee-rose-strong)] font-medium">
                        · Oggi
                      </span>
                    )}
                  </span>
                  <span
                    className={`font-serif-display text-[20px] sm:text-[22px] tabular-nums ${
                      h.closed
                        ? "text-[var(--ee-taupe)] italic"
                        : "text-[var(--ee-ink)]"
                    }`}
                  >
                    {h.time}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
